import { AppState } from 'core/redux/rootReducer';
import LarvaConnectionConfig from 'smartHome/larva/classes/LarvaConnectionConfig';
import { coreActions } from 'core/redux/actions/coreActions';
import { NotificationAlert } from 'core/classes/NotificationAlert';
import { larvaSelectors } from '../../larvaReducer';
import { AnyAction, Dispatch } from 'redux';
import { agreementSelectors } from 'agreement/redux/agreementsReducer';
import { LARVA_DOOR_ACCESS } from 'core/datasets/action';
import { isEmpty } from 'lodash';
import { fetchDoorCards, fetchDoorCodes } from 'smartHome/larva/api/larvaDoorAccessApi';
import { larvaDoorAccessActions } from '../../actions/larvaDoorAccessActions';
import { generateDoorAccessMapData } from 'smartHome/larva/helpers/larvaHelpers';
import { SetNotificationAction } from 'core/types/redux/CoreStateActions';

export const generateLarvaConfigFromState = (state: AppState): LarvaConnectionConfig | null => {
    const connectionData = larvaSelectors.connectionData(state);

    if (!connectionData) {
        return null;
    }

    return new LarvaConnectionConfig(connectionData);
};

export const generateSuccessNotification = (message: string): SetNotificationAction =>
    coreActions.notification.set(
        new NotificationAlert({
            message,
            level: NotificationAlert.SUCCESS,
        }).all,
    );

export const generateInfoNotification = (message: string): SetNotificationAction =>
    coreActions.notification.set(
        new NotificationAlert({
            message,
            level: NotificationAlert.INFO,
        }).all,
    );

export const fetchLarvaDoorAccess = async (
    connectionConfig: LarvaConnectionConfig,
    state: AppState,
    dispatch: Dispatch<AnyAction>,
): Promise<void> => {
    const supportsLarva = larvaSelectors.objectHasLarvaSupport(state);

    if (!supportsLarva) {
        return;
    }

    const isCurrentUserTenant = agreementSelectors.isCurrentUserTenant(state);
    dispatch({
        type: LARVA_DOOR_ACCESS.CHANGED_RIGHT_TO_MANAGE_ACCESSES,
        payload: isCurrentUserTenant,
    });

    const doorAccess = larvaSelectors.isAllowedToManage(state);

    if (!doorAccess) {
        return;
    }

    const connectionData = larvaSelectors.connectionData(state);

    if (!connectionData) {
        return;
    }

    // eslint-disable-next-line compat/compat
    const [cards, codes] = await Promise.all([fetchDoorCards(connectionConfig), fetchDoorCodes(connectionConfig)]);

    dispatch(larvaDoorAccessActions.storeDoorCards(cards));
    dispatch(larvaDoorAccessActions.storeDoorCodes(codes));

    if (isEmpty(cards) && isEmpty(codes)) {
        return;
    }

    const { list, doorAccessMap } = generateDoorAccessMapData({ cards, codes });

    dispatch(larvaDoorAccessActions.storeDoorAccessListViewData(list));
    dispatch(larvaDoorAccessActions.storeDoorAccessMapData(doorAccessMap));
};
